/**
 * CORE-1479 — чистое правило «открыта / под замком / не показывается» для
 * наградных реакций. Без i18n и без контекстов: его тянут хабы комнаты и ряды
 * реакций, и лишние зависимости ушли бы вместе с ним в каждый из них.
 * Подробности правила — `utils/rewardReactions`.
 */
import { REWARD_REACTION_TYPES, canonicalReactionType } from '../constants/brandReactions';
import type { RewardReactionsState } from '../types/auth';

export type RewardAccess = 'open' | 'locked' | 'hidden';

/**
 * Что показать по реакции `type`.
 *
 * `state === undefined` — сервер о награде ещё не знает (фронт выкатили
 * раньше бэкенда): ничего не запираем, сервер тоже ничего не запрёт.
 * `signedIn === false` — гость: реакции не ставит вовсе, награду не получит.
 */
export function rewardAccessOf(
  state: RewardReactionsState | null | undefined,
  signedIn: boolean,
  type: string,
  nowMs: number = Date.now(),
): RewardAccess {
  const canonical = canonicalReactionType(type);
  const rewardTypes = state?.types?.length ? state.types : REWARD_REACTION_TYPES;
  if (!rewardTypes.includes(canonical)) return 'open';
  if (!signedIn) return 'hidden';
  if (state === undefined) return 'open';
  if (state === null) return 'hidden';
  if (state.unlocked) return 'open';
  const until = state.availableUntilUtc ? Date.parse(state.availableUntilUtc) : NaN;
  return Number.isFinite(until) && until > nowMs ? 'locked' : 'hidden';
}
